"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BrandContextProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _productHelpers = require("@PetSureAustralia/petsure-react-products-library/distProductLib/helpers/productHelpers");
var _activeBrandCssMap = require("@PetSureAustralia/petsure-react-ui-library/distLib/autoGenerated/activeBrandCssMap");
var _configurations = require("@PetSureAustralia/petsure-react-products-library/distProductLib/configurations");
var _reactHelmet = require("react-helmet");
var _brandContext = require("./brandContext");
var _excluded = ["themeOverrides", "staffModeContext"],
  _excluded2 = ["themeOverrides", "staffModeContext"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useHelmetForCss = process.env.USE_HELMET_FOR_CSS;
var BrandContextProvider = exports.BrandContextProvider = function BrandContextProvider(_ref) {
  var brandConfig = _ref.brandConfig,
    useMocks = _ref.useMocks,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? 'prod' : _ref$env,
    showBrandSwitch = _ref.showBrandSwitch,
    staffMode = _ref.staffMode,
    petSureStaffMode = _ref.petSureStaffMode,
    children = _ref.children;
  var _brandConfig$theme$br = brandConfig.theme.brand,
    brandKey = _brandConfig$theme$br.key,
    broker = _brandConfig$theme$br.broker,
    gtmId = _brandConfig$theme$br.gtmId,
    gtmDataLayer = _brandConfig$theme$br.gtmDataLayer,
    products = _brandConfig$theme$br.products,
    _brandConfig$quoteToo = brandConfig.quoteTools,
    themeOverrides = _brandConfig$quoteToo.themeOverrides,
    staffModeContext = _brandConfig$quoteToo.staffModeContext,
    quoteToolsContext = _objectWithoutProperties(_brandConfig$quoteToo, _excluded);
  var _useState = (0, _react.useState)(brandKey),
    _useState2 = _slicedToArray(_useState, 2),
    activeBrandKey = _useState2[0],
    setActiveBrandKey = _useState2[1];
  var quoteToolThemeContext = (0, _helpers.DeepMergeObjects)({
    baseObject: brandConfig.theme,
    overrideObject: themeOverrides
  });
  var _useState3 = (0, _react.useState)(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, quoteToolThemeContext), quoteToolsContext), staffMode ? {
      staffInstructions: staffModeContext
    } : {}), {}, {
      productDefinitions: (0, _productHelpers.GetProductSetsForBrand)({
        env: env,
        brand: products,
        staffMode: staffMode,
        petSureStaffMode: petSureStaffMode
      }),
      tableLayoutConfiguration: (0, _configurations.getBrandSpecificProductTableConfigurations)({
        brand: products
      })
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    activeBrandContext = _useState4[0],
    setActiveBrandContext = _useState4[1];
  var applyBrandContext = (0, _react.useCallback)(function (newBrandContext) {
    var _newBrandContext$them = newBrandContext.theme.brand,
      brandKey = _newBrandContext$them.key,
      productsBrandKey = _newBrandContext$them.products,
      newBroker = _newBrandContext$them.broker,
      _newBrandContext$quot = newBrandContext.quoteTools,
      themeOverrides = _newBrandContext$quot.themeOverrides,
      staffModeContext = _newBrandContext$quot.staffModeContext,
      quoteToolsContext = _objectWithoutProperties(_newBrandContext$quot, _excluded2);
    if (brandKey !== activeBrandKey || broker !== newBroker) {
      var _quoteToolThemeContext = (0, _helpers.DeepMergeObjects)({
        baseObject: newBrandContext.theme,
        overrideObject: themeOverrides
      });
      var newBrandKey = brandKey || productsBrandKey;
      setActiveBrandKey(newBrandKey);
      setActiveBrandContext(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _quoteToolThemeContext), quoteToolsContext), staffMode ? {
        staffInstructions: staffModeContext
      } : {}), {}, {
        productDefinitions: (0, _productHelpers.GetProductSetsForBrand)({
          env: env,
          brand: productsBrandKey,
          staffMode: staffMode,
          petSureStaffMode: petSureStaffMode
        }),
        tableLayoutConfiguration: (0, _configurations.getBrandSpecificProductTableConfigurations)({
          brand: productsBrandKey
        })
      }));
    }
  }, [activeBrandKey, broker, env, petSureStaffMode, staffMode]);
  var splitPathIntoComponents = (0, _react.useCallback)(function (path) {
    var pathPattern = /[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*/;
    if (!pathPattern.test(path)) {
      /* eslint-disable-next-line no-console */
      console.error('brand config doesn\'t follow correct path pattern');
      return null;
    }
    return path.split('.');
  }, []);
  var getQuoteToolConfig = (0, _react.useCallback)(function (key) {
    var pathComponents = splitPathIntoComponents(key);
    return pathComponents.reduce(function (acc, current) {
      var _acc$current;
      return (_acc$current = acc[current]) !== null && _acc$current !== void 0 ? _acc$current : null;
    }, activeBrandContext);
  }, [activeBrandContext, splitPathIntoComponents]);
  var setQuoteToolConfig = (0, _react.useCallback)(function (key, value) {
    var pathComponents = splitPathIntoComponents(key);
    var context = activeBrandContext;
    if (pathComponents.length === 1) {
      context[key] = value;
      setActiveBrandContext(context);
      return;
    }
    var lastPathComponent = pathComponents.pop();
    var brandConfig = pathComponents.reduce(function (acc, current) {
      var _acc$current2;
      return (_acc$current2 = acc[current]) !== null && _acc$current2 !== void 0 ? _acc$current2 : null;
    }, context);
    if (!brandConfig || !brandConfig[lastPathComponent]) {
      /* eslint-disable-next-line no-console */
      console.error('Cannot set config as current config path doesn\'t exist');
      return;
    }
    brandConfig[lastPathComponent] = value;
    setActiveBrandContext(context);
  }, [activeBrandContext, splitPathIntoComponents]);
  var brandProviderValue = (0, _react.useMemo)(function () {
    return {
      activeBrandContext: activeBrandContext,
      applyBrandContext: applyBrandContext,
      useMocks: useMocks,
      staffMode: staffMode,
      showBrandSwitch: showBrandSwitch,
      env: env,
      getQuoteToolConfig: getQuoteToolConfig,
      setQuoteToolConfig: setQuoteToolConfig
    };
  }, [applyBrandContext, getQuoteToolConfig, setQuoteToolConfig, activeBrandContext, useMocks, staffMode, showBrandSwitch, env]);
  var activeBrandMapKey = (0, _react.useMemo)(function () {
    var styleSheet = activeBrandContext.brand.styleSheet;
    var cssKey = styleSheet;
    return _activeBrandCssMap.ActiveBrandMap[cssKey] ? cssKey : activeBrandKey;
  }, [activeBrandKey, activeBrandContext.brand]);
  var fallbackCssUrl = (0, _react.useMemo)(function () {
    return "".concat(_activeBrandCssMap.ActiveBrandMap.petsure, "?").concat(Date.now());
  }, []);
  var brandCssUrl = (0, _react.useMemo)(function () {
    return "".concat(_activeBrandCssMap.ActiveBrandMap[activeBrandMapKey], "?").concat(Date.now());
  }, [activeBrandMapKey]);
  return /*#__PURE__*/_react["default"].createElement(_brandContext.BrandContext.Provider, {
    value: brandProviderValue
  }, useHelmetForCss && /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, activeBrandMapKey && _activeBrandCssMap.ActiveBrandMap[activeBrandMapKey] ? /*#__PURE__*/_react["default"].createElement("link", {
    rel: "stylesheet",
    type: "text/css",
    href: brandCssUrl
  }) : /*#__PURE__*/_react["default"].createElement("link", {
    rel: "stylesheet",
    type: "text/css",
    href: fallbackCssUrl
  }), activeBrandContext.brand.cssUrls && activeBrandContext.brand.cssUrls.map(function (cssUrl, index) {
    return /*#__PURE__*/_react["default"].createElement("link", {
      key: "css_".concat(brandKey, "_").concat(index + 1),
      rel: "stylesheet",
      type: "text/css",
      href: cssUrl
    });
  }), activeBrandContext && activeBrandContext.brand.favIconUrl && /*#__PURE__*/_react["default"].createElement("link", {
    key: "favIcon",
    rel: "icon",
    href: activeBrandContext.brand.favIconUrl
  }), /*#__PURE__*/_react["default"].createElement("script", null, "\n              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n              })(window,document,'script','".concat(gtmDataLayer, "','GTM-").concat(gtmId, "');\n            "))), children);
};
BrandContextProvider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  brandConfig: _propTypes["default"].any,
  env: _propTypes["default"].oneOf(['sit', 'uat', 'preprod', 'prod']),
  useMocks: _propTypes["default"].bool,
  showBrandSwitch: _propTypes["default"].bool,
  staffMode: _propTypes["default"].bool,
  petSureStaffMode: _propTypes["default"].bool,
  // eslint-disable-next-line react/forbid-prop-types
  children: _propTypes["default"].any
};
var _default = exports["default"] = {
  BrandContext: _brandContext.BrandContext,
  BrandContextProvider: BrandContextProvider
};